import {Component, OnInit} from '@angular/core';
import {PageService} from '../../services/page.service';
import {SistemasService} from '../../services/sistemas.service';
import {production} from '../../util/constants';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  searchText = '';
  config: any;
  apps: Array<any>;
  carregando = true;
  isProd = production;

  constructor(
    private pageService: PageService,
    private sistemasService: SistemasService
  ) {}

  async ngOnInit() {
    this.config = await this.pageService.get('paginaPrincipal');
    this.apps = await this.sistemasService.getBanners();
    this.apps.forEach((app: any) => {
      if (app.sigla === 'e-SUSVE') {
        app.sigla = 'SI-PNI';
      }
      const arraySplit = app.imagem.url.split('http://');
      if (arraySplit.length > 1) {
        app.imagem.url = 'https://' + arraySplit[1];
      }
    });
    this.carregando = false;
    console.log(this.apps);
  }

  togglePopup() {
    this.config.statusPopup = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts